module.exports = __webpack_public_path__ + "static/media/a19_wba.a6e8781b.png";